var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNnIconFlagsTrDelivery = function SvgNnIconFlagsTrDelivery(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "nn-icon-flags-TR-delivery_svg__Lager_59",
    "data-name": "Lager 59",
    viewBox: "0 0 50.47 33.82"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".nn-icon-flags-TR-delivery_svg__cls-3{fill:#fff}"))), /*#__PURE__*/React.createElement("path", {
    d: "M.12.13h50.22V33.7H.12z",
    style: {
      fill: "#ed0014"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75 33.34v33.32H25V33.34zm.25-.25H24.77v33.82h50.46V33.09Z",
    style: {
      fill: "#87888a"
    },
    transform: "translate(-24.77 -33.09)"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.23 23.57a6.66 6.66 0 1 1 4.9-11.12 8.33 8.33 0 1 0 0 8.92 6.63 6.63 0 0 1-4.9 2.2",
    className: "nn-icon-flags-TR-delivery_svg__cls-3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m30.45 16.91 1.78-2.45-2.87.94-1.79-2.45v3.03l-2.87.93 2.87.93v3.03l1.79-2.45 2.87.94z",
    className: "nn-icon-flags-TR-delivery_svg__cls-3"
  })));
};
export default SvgNnIconFlagsTrDelivery;